export default "/images/smart_contracts_development/smart_contracts_audit__formal_audit.png";